import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-430c6230"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "chat_punch" }
const _hoisted_3 = { class: "ounch_head" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "功能开关", -1))
const _hoisted_5 = { class: "chat_warn" }
const _hoisted_6 = { class: "chat_content" }
const _hoisted_7 = { class: "switch_chat current" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "chat_head" }, "开关标题:", -1))
const _hoisted_9 = { class: "input_area" }
const _hoisted_10 = { class: "text_number" }
const _hoisted_11 = { class: "punch_time current" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "time_clock" }, "打卡次数:", -1))
const _hoisted_13 = { class: "punch_duration current" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "duration_time" }, "持续时长:", -1))
const _hoisted_15 = {
  key: 0,
  class: "punch_duration current"
}
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "duration_time" }, "间隔时长:", -1))
const _hoisted_17 = { class: "tip_text current" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tip_head" }, "提示文字:", -1))
const _hoisted_19 = { class: "input_area" }
const _hoisted_20 = { class: "text_number" }
const _hoisted_21 = { class: "punch_imgage" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "打卡图片:", -1))
const _hoisted_23 = { class: "upload_image" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createTextVNode("建议尺寸120*120 小于2M"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("支持jpg、jpeg、png、gif")
], -1))
const _hoisted_25 = { class: "drawer_footer" }
const _hoisted_26 = { class: "btn_group" }

import { ref } from 'vue';
import { Radio, InputNumber, Button, Input, message, Popover, Switch, Alert } from 'ant-design-vue';
import { QuestionCircleFilled } from '@ant-design/icons-vue';
import PunchList from './PunchList.vue';
import CUpload from '@/components/CUpload.vue'; // 上传图片  组件
import http from '@/api';
import { useRoute } from 'vue-router';
interface FileItem {
  uid: string;
  name?: string;
  status?: string;
  response?: any;
  url?: string;
  type?: string;
  size: number;
  originFileObj: never;
}
interface FileInfo {
  file: FileItem;
  fileList: FileItem[];
}

export default /*#__PURE__*/_defineComponent({
  __name: 'PunchClock',
  emits: ['click:onCloseLotter'],
  setup(__props, { emit }) {

const aRadio = Radio;
const aRadioGroup = Radio.Group;
const aInputNumber = InputNumber;
const aButton = Button;
const aInput = Input;
const aPopover = Popover;
const aSwitch = Switch;
const aAlert = Alert;

const route = useRoute();
const createGift = ref(true);
const getCreateStatus = (data: any) => {
  createGift.value = data;
};

const cancel = () => {
  emit('click:onCloseLotter');
};
// 上传头像
const fileList = ref([]);
const loading = ref(false);
const continuous = ref(0);
const interval = ref(0);
const pic = ref('');
const remark = ref('请及时打卡');
const status = ref(0);
const title = ref('打卡');
const type = ref(1);
const pic_url = ref('');
const uploadImage = (info: FileInfo) => {
  if (info.file?.response?.code === 200) {
    pic_url.value = info.file?.response?.data.url;
    pic.value = info.file?.response?.data.id;
  }
  if (info.file.status === 'error') {
    message.error('上传失败');
  }
  if (info.file.status === 'uploading') {
    loading.value = true;
  } else loading.value = false;
};
const imageDel = () => {
  pic_url.value = '';
  pic.value = '';
};
// 获取直播间打卡配置信息
const singInInfo = () => {
  let sing = {
    studio_id: route.params.studioId,
  };
  http.liveExpress.getSingInInfo({ params: sing }).then((res) => {
    const SingInfo = res.data.data;
    continuous.value = SingInfo.continuous;
    interval.value = SingInfo.interval;
    remark.value = SingInfo.remark;
    pic.value = SingInfo.pic;
    status.value = SingInfo.status;
    title.value = SingInfo.title;
    type.value = SingInfo.type;
    pic_url.value = SingInfo.pic_url;
    // console.log(pic_url.value, 'mmm');
  });
  // .catch((res) => {
  //   message.destroy();
  //   message.error(res.data.error);
  // });
};
singInInfo();
// 保存
const keep = () => {
  let setsing = {
    studio_id: route.params.studioId,
    title: title.value,
    type: type.value,
    interval: type.value == 0 ? interval.value : 0,
    continuous: continuous.value,
    remark: remark.value,
    pic: pic.value,
    status: status.value,
  };
  http.liveExpress
    .getSetSingInInfo(setsing)
    .then((res) => {
      if (res.data.code == 200) {
        message.destroy();
        message.success(res.data.message);
      }
    })
    .catch((res) => {
      message.destroy();
      message.error(res.data.error);
    });
};

return (_ctx: any,_cache: any) => {
  return (createGift.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            _createVNode(_unref(aSwitch), {
              checked: status.value,
              "onUpdate:checked": _cache[0] || (_cache[0] = ($event: any) => ((status).value = $event)),
              size: "small",
              class: "btns_txt",
              "checked-value": 1,
              "un-checked-value": 0
            }, null, 8, ["checked"])
          ]),
          _createElementVNode("div", {
            class: "punch_list",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (createGift.value = false))
          }, "打卡名单  >>")
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_unref(aAlert), {
            message: "此功能开启后大概延迟一分钟！",
            banner: "",
            class: "warn_progress"
          })
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _hoisted_8,
            _createElementVNode("div", _hoisted_9, [
              _createVNode(_unref(aInput), {
                value: title.value,
                "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((title).value = $event)),
                class: "area_tex",
                "show-count": "",
                maxlength: 10,
                placeholder: "请输入标题"
              }, {
                suffix: _withCtx(() => [
                  _createElementVNode("div", _hoisted_10, _toDisplayString(title.value.length) + "/10", 1)
                ]),
                _: 1
              }, 8, ["value"])
            ])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _hoisted_12,
            _createVNode(_unref(aRadioGroup), {
              value: type.value,
              "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((type).value = $event))
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(aRadio), {
                  value: 1,
                  class: "one"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("单次")
                  ]),
                  _: 1
                }),
                _createVNode(_unref(aRadio), { value: 0 }, {
                  default: _withCtx(() => [
                    _createTextVNode("多次")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["value"])
          ]),
          _createElementVNode("div", _hoisted_13, [
            _hoisted_14,
            _createVNode(_unref(aInputNumber), {
              id: "inputNumber",
              value: continuous.value,
              "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((continuous).value = $event)),
              min: 0,
              class: "current_input"
            }, null, 8, ["value"]),
            _createTextVNode(" 分钟/次 ")
          ]),
          (type.value == 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                _hoisted_16,
                _createVNode(_unref(aInputNumber), {
                  id: "inputNumber",
                  value: interval.value,
                  "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((interval).value = $event)),
                  min: 0,
                  max: 100,
                  class: "current_input"
                }, null, 8, ["value"]),
                _createTextVNode(" 分钟/次 ")
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_17, [
            _hoisted_18,
            _createElementVNode("div", _hoisted_19, [
              _createVNode(_unref(aInput), {
                value: remark.value,
                "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((remark).value = $event)),
                class: "area_tex",
                "show-count": "",
                maxlength: 10,
                placeholder: "请输入文字"
              }, {
                suffix: _withCtx(() => [
                  _createElementVNode("div", _hoisted_20, _toDisplayString(remark.value.length) + "/10", 1)
                ]),
                _: 1
              }, 8, ["value"])
            ])
          ]),
          _createElementVNode("div", _hoisted_21, [
            _hoisted_22,
            _createElementVNode("div", _hoisted_23, [
              _createVNode(CUpload, {
                "file-list": fileList.value,
                "image-name": pic_url.value,
                loading: loading.value,
                "handle-change": (info) => uploadImage(info),
                "click-stop": imageDel,
                class: "upload_image_c"
              }, null, 8, ["file-list", "image-name", "loading", "handle-change"])
            ]),
            _createVNode(_unref(aPopover), { placement: "right" }, {
              content: _withCtx(() => [
                _hoisted_24
              ]),
              default: _withCtx(() => [
                _createVNode(_unref(QuestionCircleFilled), { class: "QuestionCircleFilled" })
              ]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_25, [
          _createElementVNode("div", _hoisted_26, [
            _createVNode(_unref(aButton), {
              class: "mod_modal_btn",
              onClick: cancel
            }, {
              default: _withCtx(() => [
                _createTextVNode("取消")
              ]),
              _: 1
            }),
            (type.value == 1 && status.value)
              ? (_openBlock(), _createBlock(_unref(aButton), {
                  key: 0,
                  class: "mod_modal_btn mod_type_primary",
                  onClick: keep
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("即刻弹出")
                  ]),
                  _: 1
                }))
              : (_openBlock(), _createBlock(_unref(aButton), {
                  key: 1,
                  class: "mod_modal_btn mod_type_primary",
                  onClick: keep
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("保存")
                  ]),
                  _: 1
                }))
          ])
        ])
      ]))
    : (_openBlock(), _createBlock(PunchList, {
        key: 1,
        onCreateStatus: getCreateStatus
      }))
}
}

})